import { render, staticRenderFns } from "./SmsCreditsTab.vue?vue&type=template&id=b0752bd2&scoped=true"
import script from "./SmsCreditsTab.vue?vue&type=script&lang=js"
export * from "./SmsCreditsTab.vue?vue&type=script&lang=js"
import style0 from "./SmsCreditsTab.vue?vue&type=style&index=0&id=b0752bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0752bd2",
  null
  
)

export default component.exports